import React from 'react'
import { Switch } from "@material-ui/core";
import axios from "axios";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSnackbar } from "../../../redux/snackbar";
import "../../../Utils/_assets/sass/call-ticker.scss";
import { toAbsoluteUrl } from "../../../Utils/_helpers";
import { Alert } from "../../util/alerts";
import { Tracker } from "../../util/analytics";
import { API_ENDPOINTS } from "../../util/constants";
import * as helpers from "../../util/helpers";
import { AgentInput } from "./AgentInput";
import { handleCallServiceMessage } from "./CallService";
import { CliInput } from "./CliInput";
import * as c2cConstants from "./constants";
import * as constants from "./constants";
import { logger } from "./logger";
import { SRNumInput } from "./SRNumInput";
import { TelInput } from "./TelInput";

const MSGS = {
  200: "",
  400: "Please check your inputs",
  401: "Unauthorized call.",
  402: "Customer Number is not valid",
};

export const C2CFormWidget = (props) => {
  const [isValid, setValid] = useState(false);

  const [sr_number, setSRNUmber] = useState("");
  const [agent_number, setAgentNumber] = useState("");
  const [caller_id, setCallerId] = useState("");

  const [msg, setMsg] = useState(null);
  const [status, setStatus] = useState(0);

  const ticker_initial_customer_number = useSelector((state) => {
    return state.ticker.ticker_initial_customer_number;
  });
  const ticker_initial_agent_number = useSelector((state) => {
    return state.ticker.ticker_initial_agent_number;
  });
  const ticker_initial_srnumber = useSelector((state) => {
    return state.ticker.ticker_initial_srnumber;
  });
  const ticker_initial_callerid = useSelector((state) => {
    return state.ticker.ticker_initial_callerid;
  });
  const sip_connected = useSelector((state) => state.ticker.sip_connected);

  useEffect(() => {}, [ticker_initial_customer_number]);

  const [data, setData] = useState({
    is_promotional: false,
    customer_number: ticker_initial_customer_number,
  });

  useEffect(() => {
    const data1 = { ...data };
    data1["customer_number"] = ticker_initial_customer_number;
    setData(data1);
  }, [ticker_initial_customer_number]);

  const debug = () => {
    logger.info("C2CFormWidget", { data: data, isValid: isValid });
  };

  const reset = () => {
    setMsg(null);
    setStatus(0);
  };

  useEffect(() => {
    debug();
  }, [data]);

  const onEvent = (event) => {
    logger.info("onEvent", event);

    switch (event.type) {
      case "c2c_form::set": {
        const data1 = {};
        data1[event.key] = event.value;
        setData(prev => ({ ...prev, ...data1}));
        switch (event.key) {
          case "sr_number": {
            setSRNUmber(event.value);
            break;
          }
          case "agent_number": {
            setAgentNumber(event.value);
            break;
          }
          case "caller_id": {
            setCallerId(event.value);
            break;
          }
          default:
            return;
        }

        if (
          data.sr_number &&
          data.agent_number &&
          (data.is_promotional === true || data.caller_id)
        ) {
          setValid(true);
          logger.info("onEvent ready for call..", data1);
        }
        break;
      }
      default:
        return;
    }
    reset();
  };

  const dispatch = useDispatch();
  const attemptCall = async () => {
    if (constants.TICKER_MODE === "mock") {
      handleCallServiceMessage(constants.MOCK_EVENTS.AGENT_CALL, {}, dispatch);

      return;
    }

    if (!data.customer_number || data.customer_number.startsWith("+91")) {
      if (data.customer_number.length !== 13) {
        setMsg(MSGS[402]);
        setStatus(402);
        return;
      }
    }

    if (!data.customer_number || data.customer_number.length < 10) {
      setMsg(MSGS[402]);
      setStatus(402);
      return;
    }

    Tracker.event(
      c2cConstants.ANALYTICS.C2C_CALL_SUBMIT[0],
      c2cConstants.ANALYTICS.C2C_CALL_SUBMIT[1],
      c2cConstants.ANALYTICS.C2C_CALL_SUBMIT[2],
      c2cConstants.ANALYTICS.C2C_CALL_SUBMIT[3],
      helpers.getUser()
    );

    const url = API_ENDPOINTS.callApi;
    try {
      const params = {
        phone_number: data.customer_number,
        agent_number: agent_number,
        sr_number: sr_number,
        caller_id: caller_id ? caller_id : null,
        is_promotional: data.is_promotional,
      };

      dispatch({
        type: "onCallStateChange",
        payload: { call_customer_number: data.customer_number },
      });

      const response = await axios.get(url, { params: params });
      if (response.status === 200 && response.data) {
        setStatus(200);
        setMsg(null);
        dispatch(setSnackbar(true, "success", "Call Successfully Placed"));
      } else {
        setStatus(response.status);
        setMsg(MSGS[response.status] ? MSGS[response.status] : null);
      }
    } catch (error) {
      console.error("[TICKER]call error ", error);
      if (error.response) {
        console.error("[TICKER]call error.response ", error.response.data);
        setStatus(error.response.status);
        if (
          error.response.data &&
          error.response.data.error &&
          error.response.data.error.message
        ) {
          setMsg(error.response.data.error.message);
          dispatch(
            setSnackbar(true, "error", error.response.data.error.message)
          );
        } else {
          setMsg(
            MSGS[error.response.status] ? MSGS[error.response.status] : null
          );
        }
        return error.response;
      } else {
        setStatus(500);
        setMsg("Network Error");
      }
    }
  };

  return (
    <>
      <div className="c2c_widget_header widget_header ctc-header">
        <div className="header-content">
          <div className="oval">
            <span className="brand-logo1">
              <img
                alt=""
                className="brand-logo"
                src={toAbsoluteUrl("/media/sr/logos/menu-brand-logo.svg")}
              />
            </span>
          </div>
          <div className="heading">Click To Call</div>
        </div>
        <div
          className="header-close"
          onClick={() => {
            dispatch({ type: "Close", payload: {} });
          }}
        >
          <img
            alt=""
            className="header-close-icon"
            src={toAbsoluteUrl("/media/sr/icons/close-red.svg")}
          />
        </div>
      </div>
      <div className="row  ticker-body">
        <Alert msg={msg} onClose={reset} />
        <div className="ticker-error-alert hide">
          <div>
            <span>
              <img
                alt=""
                className="exclamation-icon"
                src={toAbsoluteUrl("/media/sr/icons/error-exclamation.svg")}
              />
            </span>
            <span>
              {data.is_promotional} {data.customer_number} {data.sr_number}
              {data.agent_number}
              {data.caller_id}
            </span>
          </div>
          <div>
            <img
              alt=""
              className="click-icon"
              src={toAbsoluteUrl("/media/sr/icons/alert-close.svg")}
            />
          </div>
        </div>
        { helpers.getUserTimezone() == "Asia/Kolkata" &&
          <div className="col-12 mt-5">
            <Switch
              onChange={(e) => {
                onEvent({
                  type: "c2c_form::set",
                  key: "is_promotional",
                  value: e.target.checked,
                });
              }}
              value={data.is_promotional}
              inputProps={{ "aria-label": "primary checkbox" }}
            />
            <span className="c2c_promotional">Make Promotional C2C</span>
          </div>
        }
        <div className="col-12 mt-5">
          <TelInput
            onEvent={onEvent}
            status={status}
            ticker_initial_customer_number={ticker_initial_customer_number}
            moduleName="c2c_ticker"
            showValidationMessage={true}
          />
        </div>
        <div className="col-12 mt-5">
          <SRNumInput
            onEvent={onEvent}
            ticker_initial_srnumber={ticker_initial_srnumber}
          />
        </div>

        <div className="col-12 mt-5">
          <AgentInput
            onEvent={onEvent}
            ticker_initial_agent_number={ticker_initial_agent_number}
          />
        </div>

        <div className="col-12 mt-5">
          <CliInput
            onEvent={onEvent}
            sr_number={ticker_initial_srnumber}
            selectedCallerId={ticker_initial_callerid}
            is_promotional={data.is_promotional}
          />
        </div>

          {!sip_connected && helpers.isFeatureEnabledProfile('sip_url_flag') &&
            <div className='d-flex justify-content-center'> 
              <p className='text-center mb-0' style={{ color: 'red' }}><i>WebRTC/SIP connection lost. Please establish connection and try again.</i></p> 
            </div>
          }

        <div
          className="col-12 dial-call-section"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <a
            className="call-btn-c2c dddial-call-btn click-icon"
            href="/#"
            style={{
              display: "flex",
              justifyContent: "center",
              pointerEvents: "all",
            }}
            onClick={(e) => {
              e.preventDefault();
              attemptCall();
            }}
          >
            <img
              alt=""
              className="dial-call-icon initial-dilar"
              style={{ pointerEvents: "all" }}
              src={toAbsoluteUrl("/media/sr/icons/dial-call-white.svg")}
            />
            Call
          </a>
        </div>
      </div>
    </>
  );
};
